/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { comboSuggestionSchema } from "./comboSuggestionSchema.ts";

export const combosListPathOrgUnitIdSchema = z.uuid();

export const combosListQueryUseHotMenuSchema = z.boolean().optional().default(true).describe("Использовать кэшированные данные (hot combo) из БД");

export const combosListStatus200Schema = z.array(comboSuggestionSchema);

export const combosListResponseSchema = combosListStatus200Schema;
